module.exports = __webpack_public_path__ + "static/pic1-f425de6a678655f14352fb05b817f761.png";